import * as types from 'actions/types';
import { createReducer, successType } from 'lib/callAPI';

const assistantReduser = (state = null, action) => {
  switch (action.type) {
    case successType(types.GET_ASSISTANT_LIST):
      return action.response;
    default:
      return state;
  }
};

export default createReducer(types.GET_ASSISTANT_LIST, assistantReduser);
